import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog } from '@/shared/ui/Dialog';
import { Button } from '@/shared/ui/lib/Button';

import {
  ChangeEmailDialogProps,
  ChangeEmailFormDataType,
} from '../model/types';
import { useChangeEmail } from '../model/useChangeEmail';

import { ChangeEmailForm } from './ChangeEmailForm';

const CHANGE_EMAIL_FORM = 'changeEmailForm';
const CHANGE_EMAIL_FORM_DIALOG = 'changeEmailFormDialog';

export const ChangeEmailDialog = ({
  open,
  onClose,
}: ChangeEmailDialogProps) => {
  const { t } = useTranslation();

  const { changeEmail, isPending } = useChangeEmail();

  const handleCloseDialog = () => {
    onClose?.();
  };

  const handleSubmit = (data: ChangeEmailFormDataType) => {
    return changeEmail(data, handleCloseDialog);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      id={CHANGE_EMAIL_FORM_DIALOG}
      title={t('settings:changeEmail.title')}
      leftButtonSlot={
        <Button onClick={handleCloseDialog} variant="outlined">
          {t('common:buttons.cancel')}
        </Button>
      }
      rightButtonSlot={
        <Button
          type="submit"
          form={CHANGE_EMAIL_FORM}
          variant="contained"
          color="primary"
          loading={isPending}
        >
          {t('common:buttons.save')}
        </Button>
      }
    >
      <ChangeEmailForm id={CHANGE_EMAIL_FORM} onSubmit={handleSubmit} />
    </Dialog>
  );
};
